var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.99987C3.75 7.20715 3.96841 6.46456 4.34784 5.82872V3.13159H1.65072C0.58025 4.52184 0 6.21619 0 7.99987C0 9.78356 0.58025 11.4779 1.65072 12.8682H4.34784V10.171C3.96841 9.53519 3.75 8.79259 3.75 7.99987Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.25L6.125 14.125L8 16C9.78372 16 11.478 15.4197 12.8683 14.3493V11.655H10.174C9.53262 12.0358 8.78691 12.25 8 12.25Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34752 10.1711L1.65039 12.8683C1.86233 13.1435 2.09311 13.4071 2.34283 13.6569C3.85383 15.1678 5.8628 16 7.99967 16V12.25C6.44892 12.25 5.08977 11.415 4.34752 10.1711Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.99989C16 7.51317 15.9559 7.02554 15.869 6.5506L15.7987 6.16626H8V9.91626H11.7954C11.4268 10.6494 10.8601 11.2476 10.174 11.6549L12.8682 14.3492C13.1435 14.1373 13.4071 13.9065 13.6568 13.6568C15.1678 12.1457 16 10.1368 16 7.99989Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0052 4.99478L11.3367 5.32622L13.9883 2.67459L13.6569 2.34316C12.1459 0.832156 10.1369 0 8 0L6.125 1.875L8 3.75C9.13519 3.75 10.2025 4.19206 11.0052 4.99478Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9997 3.75V0C5.86283 0 3.85386 0.832156 2.34283 2.34313C2.09311 2.59284 1.86233 2.85644 1.65039 3.13172L4.34752 5.82884C5.0898 4.585 6.44895 3.75 7.9997 3.75Z",
    fill: "#EB4132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.a118e11f.svg";
export { ForwardRef as ReactComponent };